import React from 'react';
import './Impact.css';

function Impact() {
  const stats = [
    {
      number: '20+',
      label: 'Years of Service',
      description: 'Since 2004-2005'
    },
    {
      number: '2 Weeks',
      label: 'Per Mission',
      description: 'Comprehensive surgical care'
    },
    {
      number: '40-50',
      label: 'Children Per Mission',
      description: 'Complex surgical cases'
    },
    {
      number: '100%',
      label: 'Donation Impact',
      description: 'Every dollar supports care'
    }
  ];

  const impacts = [
    {
      title: 'Life-Changing Surgery',
      description: 'Complex pediatric surgery & urology procedures that cannot be safely performed locally, giving children a chance at a healthy life.',
      image: '/images/manuel.png'
    },
    {
      title: 'Medical Education',
      description: 'Training local physicians and residents through hands-on collaboration, building lasting surgical capacity in Cambodia.',
      image: '/images/impact-2.jpg'
    },
    {
      title: 'Essential Equipment',
      description: 'Providing high-value medical instruments and equipment to partner hospitals, enabling better care for years to come.',
      image: '/images/impact-3.jpg'
    }
  ];

  return (
    <section className="impact section">
      <div className="container">
        <div className="section-header">
          <span className="section-subtitle">Our Impact</span>
          <h2 className="section-title">Transforming Lives Through Specialized Surgery</h2>
          <p className="section-description">
            For over 20 years, we've provided complex pediatric surgery & urology to children 
            in Cambodia who would otherwise have no access to these life-changing procedures. 
            Our impact extends beyond surgery through education and capacity building.
          </p>
        </div>

        <div className="stats-grid">
          {stats.map((stat, index) => (
            <div key={index} className="stat-card">
              <div className="stat-content">
                <span className="stat-number">{stat.number}</span>
                <h3 className="stat-label">{stat.label}</h3>
                <p className="stat-description">{stat.description}</p>
              </div>
              <div className="stat-decoration"></div>
            </div>
          ))}
        </div>

        <div className="impact-grid">
          {impacts.map((impact, index) => (
            <div key={index} className="impact-card">
              <div className="impact-image">
                <img src={impact.image} alt={impact.title} />
                <div className="impact-overlay">
                  <h3 className="impact-title">{impact.title}</h3>
                </div>
              </div>
              <div className="impact-content">
                <p className="impact-description">{impact.description}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="impact-cta">
          <div className="cta-content">
            <h3 className="cta-title">Help Us Transform More Young Lives</h3>
            <p className="cta-description">
              Your support enables us to continue providing complex pediatric surgery to 
              children in Cambodia, supply essential medical equipment, and train local 
              medical professionals. Together, we can give more children a chance at life.
            </p>
          </div>
          <div className="cta-actions">
            <a href="/contact" className="btn btn-primary">Support Our Mission</a>
            <a href="/about" className="btn btn-secondary">Learn More</a>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Impact;

